<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 展示来場状況ダウンロードファイル（作成・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>展示来場状況ダウンロードファイル（作成・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-exhibit-transit-download-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> メモ
        </div>
        <div class="manual-explain">
          メモを設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> イベント
        </div>
        <div class="manual-explain">
          ダウンロード対象のイベントを選択します。<br>
          編集時は変更不可です。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 展示
        </div>
        <div class="manual-explain">
          ダウンロード対象の展示を選択します。<br>
          イベント未選択時と編集時は変更不可です。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 作成期間（開始日時）
        </div>
        <div class="manual-explain">
          集計期間（開始日時）を設定します。<br>
          期間に該当する登録日時の展示来場状況を出力します。<br>
          編集時は変更不可です。<br>
          全件ダウンロード時は指定不要です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 作成期間（終了日時）
        </div>
        <div class="manual-explain">
          集計期間（終了日時）を設定します。<br>
          期間に該当する登録日時の展示来場状況を出力します。<br>
          編集時は変更不可です。<br>
          全件ダウンロード時は指定不要です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 作成ボタン
        </div>
        <div class="manual-explain">
          クリックすることでダウンロードファイルの作成を開始します。<br>
          編集時はダウンロードファイルの作成をせずにメモの更新をします。<br>
          ※ダウンロードファイルの作成には時間がかかる場合があります。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Exhibit Visitor Status Download File (Create/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Exhibit Visitor Status Download File (Create/Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-exhibit-transit-download-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Memo
        </div>
        <div class="manual-explain">
          Set a memo.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Event
        </div>
        <div class="manual-explain">
          Select the event for download.<br>
          Cannot be changed when editing.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Exhibit
        </div>
        <div class="manual-explain">
          Select the exhibit for download.<br>
          Cannot be changed when no event is selected or when editing.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Creation Period (Start Date/Time)
        </div>
        <div class="manual-explain">
          Set the aggregation period (start date/time).<br>
          Outputs exhibit visitor status with registration date/time within the period.<br>
          Cannot be changed when editing.<br>
          Not required when downloading all records.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Creation Period (End Date/Time)
        </div>
        <div class="manual-explain">
          Set the aggregation period (end date/time).<br>
          Outputs exhibit visitor status with registration date/time within the period.<br>
          Cannot be changed when editing.<br>
          Not required when downloading all records.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to start creating the download file.<br>
          When editing, only the memo is updated without creating a download file.<br>
          *Creating the download file may take some time.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>